import { useContext } from 'react';

import { ToastContext, type ToastPayload } from './ToastContext';
import { type MakeToastBuilderReturn, makeToastBuilder } from './utils/makeToastBuilder';

export const useToast = (props?: ToastPayload): MakeToastBuilderReturn => {
  const { showAlert } = useContext(ToastContext);

  return makeToastBuilder(showAlert, props);
};
